import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const getNavMenuOptions = async () => {
  const res = await axios.middleware("/aluno.asmx/Lista_Menu_Dinamico", {
    params: {
      alunoid: _cookies.getItem("auth").user?.alunoid,
    },
  });

  return res?.[0]?.data;
};

export const useNavMenuOptions = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryFn: getNavMenuOptions,
    queryKey: ["navMenuOptions"],
  });
};
